var map = {
	"./CUSHION MBR.png": "ZP27",
	"./CUSHION.png": "IX7V",
	"./EMERALD.png": "ah6x",
	"./HEART.png": "SLi+",
	"./MARQUISE.png": "85BI",
	"./OVAL.png": "N6fr",
	"./PEAR.png": "IYWr",
	"./PRINCESS.png": "NHS1",
	"./RADIANT.png": "TgP4",
	"./ROUND.png": "+eBR",
	"./TRIANGULAR.png": "0Tng",
	"./gia_filter_bottom.png": "0vyn",
	"./gia_slide.png": "koRN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7gZH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gia ^\.\/.*\.png$
// module id = 7gZH
// module chunks = 0